import Leave from "../../components/Dashboard/LeaveCharts";
import MyAppraisal from "../../components/Dashboard/MyAppraisal";
import MyGoal from "../../components/Dashboard/MyGoal";
import Announcement from "../../components/Dashboard/Announcemnet/Announcement";
import Vision from "../../components/Dashboard/Vision";
import Mission from "../../components/Dashboard/Mission";
import Loginbg from "../Login/Loginbg";
import MainLayout from "../MainLayout";
import Dummylayout from "../Dummylayout";
import TeamUpdate from "../../components/Dashboard/Teamupdate/TeamUpdate";

import React, { useState, useEffect } from "react";
import { Alert, Modal, Button } from "react-bootstrap";
import { baseURL } from "../../config";

function Dashboard() {
  const [show, setShow] = useState(false);

  const [notificationmsg, setNotificationMsg] = useState("");
  const [notificationId, setNotificationId] = useState(0);

  const handleClose = () => setShow(false);

  const [showModal, setShowModal] = useState(false);
  const handleShowUser = () => setShowModal(false);
  const handleClose1 = () => {
    handleShowUser(false); // Set showModal to false to hide the modal
  };

  const acknowledge = async () => {
    try {
      let reslt = await fetch(
        `${baseURL}/acknowledgeNotification?nid=` + notificationId
      );
      setNotificationId(null);
      setShow(false);
    } catch (e) {}
  };

  let role = localStorage.getItem("userrole");
  // let role = "MANAGER";

  let searchString = "ROLE_";
  let rolename = "";

  useEffect(() => {
    const fetchEmployeeNotifications = async () => {
      try {
        let eid = localStorage.getItem("employeeid");
        let userid = localStorage.getItem("userid");
        let reslt = await fetch(
          `${baseURL}/getnotifications?eid=` + eid + "&id=" + userid
        );
        const res = await reslt.json();
        if (res.notifications.length > 0) {
          let msg = res.notifications[0].notification;
          let id = res.notifications[0].id;
          setNotificationMsg(msg);
          setNotificationId(id);

          if (msg) {
            setShow(true);
          }
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    };
    fetchEmployeeNotifications();
    setShowModal();
  }, []);

  if (role)
    rolename = role.substring(role.indexOf(searchString) + searchString.length);
  else rolename = "guest";

  if (
    rolename === "MANAGER" ||
    rolename === "HR" ||
    rolename === "SUPERVISOR" ||
    rolename === "SUPER ADMIN" ||
    rolename === "SENIOR HR MANAGER"
  )
    return (
      <>
        <Dummylayout />

        <div className="container m-auto pl-5 ">
          <div className="container mx-5 d-flex  pl-3 mx-3">
            <TeamUpdate />
          </div>

          <div className="col-11 m-auto pl-4 d-flex flex-wrap">
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>New message for you </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Alert variant="danger">
                  <p>{notificationmsg}</p>
                </Alert>
              </Modal.Body>
              <Modal.Footer>
                <a
                  href="#"
                  className="mt-4 btn btn-danger m-2"
                  onClick={acknowledge}
                >
                  {" "}
                  Acknowledge and Close
                </a>
              </Modal.Footer>
            </Modal>

            <div className="col-lg-6">
              {/* <Vision /> */}
              {/* <div className="mt-5"></div> */}
              <Mission />
            </div>
            <div className="col-lg-6">
              <Announcement />
            </div>
          </div>
        </div>

        <br></br>
        <br></br>
        <br></br>
      </>
    );
  else if (rolename === "USER")
    return (
      <>
        <Dummylayout />
        <div className="container m-auto pl-5 ">
          <div className="container mx-5 d-flex  pl-3 mx-3">
            <TeamUpdate />
          </div>

          <div className="col-11 m-auto pl-4 d-flex  flex-wrap">
            <Alert
              variant="danger"
              className="mx-5 "
              show={notificationId}
              onClose={() => setShow(false)}
              dismissible={false}
            >
              <Alert.Heading>New message for you </Alert.Heading>
              <p>
                {notificationmsg}
                <br></br>
                <Alert.Link
                  className="mt-4 btn btn-success m-2 text-white"
                  href="/myappraisal"
                >
                  View your Appraisal
                </Alert.Link>
                <a
                  href="#"
                  className="mt-4 btn btn-danger m-2"
                  onClick={acknowledge}
                >
                  {" "}
                  Acknowledge and Close
                </a>
              </p>
            </Alert>

            {/* <Modal show={handleShowUser} onHide={handleClose1} centered>
        <Modal.Header closeButton>
          <Modal.Title>New message for you</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Alert variant="danger">
                        <p>{notificationmsg}</p>
                        <a className='text-danger' href="/myappraisal">View your Appraisal</a>.
                    </Alert>

        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={handleClose1}>
                        Close
                    </Button>
        </Modal.Footer>
      </Modal>  */}

            {/* <div className="col-lg-6 mt-1">
              <Vision />
            </div>
            <div className="col-lg-6 mt-1">
              <Announcement />
            </div>
            <div className="col-lg-6">
              <Mission />
            </div> */}

            <div className="col-lg-6">
              {/* <Vision /> */}
              {/* <div className="mt-5"></div> */}
              <Mission />
            </div>
            <div className="col-lg-6">
              <Announcement />
            </div>
          </div>
        </div>
      </>
    );
}

export default Dashboard;
